// extracted by mini-css-extract-plugin
module.exports = {"slot":"entry_slot__9rWb2","rounded":"entry_rounded__3E9ws","scaled":"entry_scaled__1KIdG","dex":"entry_dex__2F-nQ","pokemon":"entry_pokemon__2YEUb","anchor":"entry_anchor__1bBYH"};